import React, { useState, useEffect, useRef } from "react";
import { useMediaQuery } from "@mui/material";

const DigitalAssets = () => {
  const [count1, setCount1] = useState(0);
  const [count2, setCount2] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [fade, setFade] = useState(false);
  const [hasCounted, setHasCounted] = useState(false);
  const sectionRef = useRef(null);
  
  const isMobile = useMediaQuery("(max-width: 767px)");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasCounted) {
            setIsVisible(true);
            setCount1(0);
            setCount2(0);
            setFade(false);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [hasCounted]);

  useEffect(() => {
    if (isVisible && !hasCounted) {
      let start1 = 0;
      const end1 = 10;
      const duration1 = 1000;
      const incrementTime1 = Math.floor(duration1 / end1);

      const counter1 = setInterval(() => {
        start1 += 1;
        setCount1(start1);
        if (start1 === end1) {
          clearInterval(counter1);
          setHasCounted(true);
        }
      }, incrementTime1);

      let start2 = 0;
      const end2 = 8;
      const duration2 = 1000;
      const incrementTime2 = Math.floor(duration2 / end2);

      const counter2 = setInterval(() => {
        start2 += 1;
        setCount2(start2);
        if (start2 === end2) {
          clearInterval(counter2);
          setFade(true);
        }
      }, incrementTime2);

      return () => {
        clearInterval(counter1);
        clearInterval(counter2);
      };
    }
  }, [isVisible, hasCounted]);

  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: isMobile ? "center" : "space-between",
      alignItems: "center",
      padding: isMobile ? "10px" : "20px",
      marginTop: isMobile ? "40px" : "40px",
      marginBottom: isMobile ? "30px" : "10px",
      backgroundColor: "#E8E4E1",
      maxWidth: "1300px",
      marginLeft: "auto",
      marginRight: "auto",
      textAlign: isMobile ? "center" : "left",
    },
    leftSection: {
      flex: 1,
      display: "flex",
      justifyContent: isMobile ? "center" : "flex-start",
      marginBottom: isMobile ? "20px" : "0",
    },
    text: {
      fontSize: isMobile ? "30px" : "40px",
      background: "linear-gradient(90deg, #2D669B 0%, #0582CA 100%)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent",
      fontWeight: "bold",
    },
    rightSection: {
      flex: 1,
      display: "flex",
      justifyContent: isMobile ? "center" : "flex-end",
      gap: "30px",
      flexDirection: isMobile ? "column" : "row",
    },
    numberContainer: {
      display: "flex",
      alignItems: isMobile ? "center" : "flex-start",
      flexDirection: isMobile ? "column" : "row", // Column on mobile, row on desktop
    },
    number: {
      fontSize: isMobile ? "2.5rem" : "4rem",
      color: "#0582CA",
      fontWeight: "bold",
    },
    textContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: isMobile ? "center" : "flex-start", // Center text on mobile
      marginLeft: isMobile ? "0" : "10px",
    },
    unitText: {
      fontSize: isMobile ? "1.5rem" : "2rem",
      color: "#0582CA",
      fontWeight: "600",
      marginTop: isMobile ? "5px" : "10px",
      marginBottom: isMobile ? "5px" : "0px", // Add space below text on mobile
      paddingBottom:"0px",
      maxHeight:"40px",
     },
    description: {
      fontSize: isMobile ? "0.9rem" : "1rem",
      color: "#919191",
      textAlign: "center",
      opacity: fade ? 1 : 0,
      transform: fade ? "translateX(0)" : "translateX(-20px)",
      transition: "opacity 1s ease, transform 1s ease",
      paddingTop:"0px"
    },
  };

  return (
    <section style={{ backgroundColor: '#E8E4E1', padding: '1rem 0', paddingBottom: '3rem', position: 'relative', fontFamily: "Poppins" }}>
      <div style={styles.container} ref={sectionRef}>
        {/* Left Section: Title */}
        <div style={styles.leftSection}>
          <h2 style={styles.text}>
            Fast and Flexible
            <br />
            Integration
          </h2>
        </div>

        {/* Right Section: Counters */}
        <div style={styles.rightSection}>
          {/* First Counter */}
          <div style={styles.numberContainer}>
            <span style={styles.number}>{count1}</span>
            <div style={styles.textContainer}>
              <span style={styles.unitText}>DAYS</span>
              <p style={styles.description}>For simple integration</p>
            </div>
          </div>

          {/* Second Counter */}
          <div style={styles.numberContainer}>
            <span style={styles.number}>{count2}</span>
            <div style={styles.textContainer}>
              <span style={styles.unitText}>WEEKS</span>
              <p style={styles.description}>For complex integration</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DigitalAssets;
